import * as Yup from 'yup';

export const MAX_PHOTOS = 3;

export const initialValues = {
  Photo: [],
};

// Function to validate file extensions
export const validateFileType = (file) => {
  const EXTENSIONS = ['.jpg', '.jpeg'];
  if ((file && file.name)) {
    const fileExtension = file.name.split('.').pop().toLowerCase();
    return EXTENSIONS.includes(`.${fileExtension}`);
  }
  if ((file && !file.name)) {
    const fileExtension = file.split('.').pop().toLowerCase();
    return EXTENSIONS.includes(`.${fileExtension}`);
  }
  return false;
};

export const UploadBolSchema = Yup.object().shape({
  Photo: Yup.array()
    .label('BOL Photos')
    .min(1, 'Please add at least one photo of the Bill of Lading.')
    .max(MAX_PHOTOS, `You can upload up to ${MAX_PHOTOS} photos.`)
    .test(
      'noInvalidPhotos',
      'Please remove or retake the invalid photo(s) before uploading.',
      (value) => Array.isArray(value) && value.every((photo) => !photo.error),
    ),
});
